import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentRequestProjectType } from '@warema/shared/models';

@Pipe({
    name: 'appointmentProjectTypePipe',
})
export class AppointmentProjectTypePipe implements PipeTransform {
    public transform(projectType: AppointmentRequestProjectType): string {
        switch (projectType) {
            case AppointmentRequestProjectType.Renovation:
                return 'RENOVATION';

            case AppointmentRequestProjectType.NewBuilding:
                return 'NEW_BUILDING';

            default:
                return 'UNKNOWN';
        }
    }
}
